import { AmendObservationPhotos } from "./components/AmendObservationPhotos"

export default AmendObservationPhotos